import styled from 'styled-components'

export const Mask = styled.div`
  background-image: url('/assets/images/login-mask.png');
  background-size: cover;
  height: 100%;
`
